export const VERTICAL_KEY_MAP = {
  health_wellness: 'health',
};

export const VERTICAL_KEYS = [
  'beauty', 'health', 'fitness', 'education',
  'automotive', 'real_estate', 'professional_services', 'generic',
];

export function normalizeVertical(raw) {
  if (!raw) return 'generic';
  const mapped = VERTICAL_KEY_MAP[raw];
  if (mapped) return mapped;
  if (VERTICAL_KEYS.includes(raw)) return raw;
  return 'generic';
}
